import { Flex as AntFlex, FlexProps } from 'antd';

export const Flex = AntFlex;

export type { FlexProps };
